@if (loader.visible()) {
  <div class="loader-backdrop" aria-live="polite" aria-label="Loading">
    <!-- <div class="loader-spinner">
      <div class="spinner-ring"></div>
    </div> -->
    <ia-dot-loader
      [width]="'200px'"
      [height]="'60px'"
      [loop]="true"
      [autoplay]="true"
    ></ia-dot-loader>
  </div>
}
